// Bestimme die API-URL basierend auf der Umgebung
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Lokale Entwicklung - SQLite Backend auf localhost:5000
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000/api';
  }

  // Produktion: ServerTown (time.cerpax.ch)
  return `${window.location.protocol}//${window.location.hostname}/api`;
};

export const API_BASE_URL = getApiBaseUrl(); 